import { startRegistration, startAuthentication, browserSupportsWebAuthn } from "@simplewebauthn/browser";
import api from "./api";

export const passkeySupported = () => browserSupportsWebAuthn();

export const inIframe = () => {
  try { return window.self !== window.top; } catch { return true; }
};

export async function registerPasskey(nickname) {
  const { data } = await api.post("/auth/passkey/register/begin");
  const credential = await startRegistration({ optionsJSON: data.options });
  await api.post("/auth/passkey/register/complete", { flow_id: data.flow_id, credential, nickname });
}

export async function loginPasskey(email) {
  const { data } = await api.post("/auth/passkey/login/begin", email ? { email } : {});
  const credential = await startAuthentication({ optionsJSON: data.options });
  const res = await api.post("/auth/passkey/login/complete", { flow_id: data.flow_id, credential });
  return res.data;
}

// Step-up re-authentication: re-verify an existing passkey to unlock a protected item/file.
export async function stepUp() {
  const { data } = await api.post("/auth/step-up/begin", {});
  const credential = await startAuthentication({ optionsJSON: data.options });
  const res = await api.post("/auth/step-up/complete", { flow_id: data.flow_id, credential });
  return res.data.step_up_token;
}
